import {View} from 'native-base';
import React from 'react';

import FilterBarAccordion from 'components/FilterBarAccordion';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';
import {OfferFiltersProperty} from 'models/OfferFilters';

import OfferFilter from '../Filter';
import OfferFilterList from '../List';

export interface OfferFilterPropertiesProps {
  list: OfferFiltersProperty[];
  selected?: OfferFiltersProperty[];
  onSelect?: (item: OfferFiltersProperty) => void;
  toggle?: boolean;
  onToggle?: () => void;
  onSelectAll?: () => void;
  availableProperties?: string[];
  propertiesOfferCount: {[key: string]: number};
  totalPropertyOffersCount: number;
}

const OfferFilterProperties: React.FC<OfferFilterPropertiesProps> = props => {
  const {trackAdobeEvent} = useTrackEvent();
  const {
    list,
    selected,
    onSelect,
    toggle,
    onToggle,
    onSelectAll,
    availableProperties,
    propertiesOfferCount,
    totalPropertyOffersCount,
  } = props;
  const handleSelect = (item: OfferFiltersProperty) => () => {
    onSelect && onSelect(item);
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {name: 'rewards filter'},
      rewards: {category: 'PROPERTIES', filter: item.name},
    });
  };

  const isSelected = (item: OfferFiltersProperty) =>
    selected ? selected.indexOf(item) !== -1 : false;

  const showAltText = () => {
    if (list && selected) {
      if (!list.length) {
        return undefined;
      } else if (list.length === 1) {
        return list[0].name;
      } else if (selected.length) {
        return selected
          .slice(0, 2)
          .map(item => item.name)
          .join(', ');
      }
      return 'All Hotels & Resorts';
    }
  };

  return (
    <View width="100%">
      <FilterBarAccordion
        toggle={toggle}
        accordionTop={
          <OfferFilter
            title="HOTELS & RESORTS"
            icon="landmark"
            altText={showAltText()}
            count={totalPropertyOffersCount}
            isOpen={toggle}
            onToggle={onToggle}
            more={
              list.length === selected?.length
                ? undefined
                : selected && selected.length > 2
                  ? selected.length - 2
                  : undefined
            }
          />
        }
        accordionBody={
          <OfferFilterList
            isPropertyList
            list={list}
            onSelect={list.length > 1 ? handleSelect : undefined}
            isSelected={isSelected}
            hasAllOption={true}
            onSelectAll={onSelectAll}
            allSelected={
              list.length === selected?.length || selected?.length === 0
            }
            availableProperties={availableProperties}
            offersCount={propertiesOfferCount}
          />
        }
      />
    </View>
  );
};

export default OfferFilterProperties;
